export interface CurrencyModel {
  code: string;
  name: string;
  nameEn: string;
  id?: number;
}
